import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

// The iOS Switch Component
const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#65C466",
        opacity: 1,
        border: 0,
        ...theme.applyStyles("dark", {
          backgroundColor: "#2ECA45",
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.grey[100],
      ...theme.applyStyles("dark", {
        color: theme.palette.grey[600],
      }),
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
      ...theme.applyStyles("dark", {
        opacity: 0.3,
      }),
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#E9E9EA",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    ...theme.applyStyles("dark", {
      backgroundColor: "#39393D",
    }),
  },
}));

// Child Component - Translate Switch
// Clean Child Component with label on left
const TranslateSwitch = ({ onTranslateChange, translateValue }) => {
  return (
    <FormControlLabel
      control={
        <IOSSwitch
          checked={translateValue}
          onChange={(event) => onTranslateChange(event.target.checked)}
        />
      }
      label="Enable Translation"
      labelPlacement="start"
      sx={{
        margin: 0,
        gap: "12px", // This creates the gap
        fontFamily: "'Host Grotesk', sans-serif",
            color: "#2c4e80",
        "& .MuiFormControlLabel-label": {
          fontFamily: "'Host Grotesk', sans-serif",
          // marginTop: "16px",
        },
      }}
    />
  );
};

// Alternative Child Component with Stack Layout
const TranslateSwitchStack = ({ onTranslateChange, translateValue }) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2, marginTop:"5px"}}>
      <Typography sx={{ fontFamily: "'Host Grotesk', sans-serif" }}>
        Original
      </Typography>
      <IOSSwitch
        checked={translateValue}
        onChange={(event) => onTranslateChange(event.target.checked)}
      />
      <Typography sx={{ fontFamily: "'Host Grotesk', sans-serif" }}>
        Translated
      </Typography>
    </Stack>
  );
};

// Example usage component

export { IOSSwitch, TranslateSwitch, TranslateSwitchStack };